import { render, staticRenderFns } from "./QnaUpdate.vue?vue&type=template&id=f5e6d24e&scoped=true"
import script from "./QnaUpdate.vue?vue&type=script&lang=js"
export * from "./QnaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e6d24e",
  null
  
)

export default component.exports